/* eslint-disable import/no-anonymous-default-export */
import apiClient from "./api";

export default {
  contactSupport(req) {
    return apiClient.post("api/contact/support", req);
  },
};
